export default {"src":"/_next/static/media/pharmacy-otc.33455e79.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};